<template>
  <svg
    width="43"
    height="18"
    viewBox="0 0 43 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="2.5" cy="9" r="2" fill="#F08B71" />
    <circle cx="10.5" cy="9" r="2" fill="#F08B71" />
    <circle cx="18.5" cy="9" r="2" fill="#F08B71" />
    <circle cx="26.5" cy="9" r="2" fill="#F08B71" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M34.1671 17.3329C33.7404 17.3329 33.3138 17.1696 32.9888 16.8446C32.3371 16.1929 32.3371 15.1396 32.9888 14.4879L38.4971 8.9796L33.1971 3.49127C32.5588 2.82793 32.5771 1.77293 33.2388 1.1346C33.9021 0.496268 34.9571 0.514601 35.5954 1.1746L42.0321 7.84127C42.6638 8.49627 42.6554 9.5346 42.0121 10.1779L35.3454 16.8446C35.0204 17.1696 34.5938 17.3329 34.1671 17.3329Z"
      fill="#F08B71"
    />
  </svg>
</template>
